import type {
  SleepLogConfig,
  SleepLogDayData,
  WidgetConfig,
  WidgetWeekEntry,
} from "@/lib/schema";
import { countPhrase, sumOverDays } from "@/widgets/describe";
import { getWidgetModule } from "@/widgets/registry";
import type { DayWidgetModule } from "@/widgets/types";
import { DayView } from "./DayView";
import { SettingsEditor } from "./SettingsEditor";
import { maxScoreWeek, scoreDay, scoreWeek } from "./scoring";
import { validate } from "./validate";

function defaults(existing: WidgetConfig[]): SleepLogConfig {
  const dayWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "day",
  );
  const maxRow = dayWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  return {
    id: crypto.randomUUID(),
    kind: "sleep-log",
    label: "Søvn",
    row: maxRow + 1,
    column: 0,
    enabled: true,
    asleepTarget: "00:00",
    awakeTarget: "07:00",
    points: 2,
    intervalMinutes: 15,
    reductionPerInterval: 0.5,
    weekGoal: Number.NaN,
  };
}

// A night counts the moment either time is in: one time alone is a half-logged
// night, and losing it is still losing something.
function describeWeekData(entry: WidgetWeekEntry): string | null {
  const nights = sumOverDays<SleepLogDayData>(entry, (day) =>
    day?.asleepAt || day?.awokeAt ? 1 : 0,
  );
  return countPhrase(nights, "natt", "netter");
}

export const sleepLog: DayWidgetModule<SleepLogConfig> = {
  kind: "sleep-log",
  label: "Søvn",
  scope: "day",
  scoring: "points",
  defaults,
  validate,
  SettingsEditor,
  DayView,
  describeWeekData,
  scoreDay,
  scoreWeek,
  maxScoreWeek,
};
